import { useMemo } from "react"

export function usePropsObject(props) {
    return useMemo(
        () => props,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        props && typeof props === "object" ? (Array.isArray(props) ? props : Object.values(props)) : []
    )
}
